/* global debounce */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.disclosure = this.closest('details');

      if (this.disclosure && this.disclosure.matches('.cart-note-disclosure')) {
        this.cartNoteToggle = this.disclosure.querySelector('.js-show-note');
      }

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.init();
    }

    init() {
      this.fetchCartContents();

      this.addEventListener('change', debounce((evt) => {
        if (this.cartNoteToggle) {
          const label = evt.target.value ? theme.strings.editCartNote : theme.strings.addCartNote;
          if (this.cartNoteToggle.textContent !== label) this.cartNoteToggle.textContent = label;
        }

        this.fetchRequestOpts.body = JSON.stringify({ note: evt.target.value });
        fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
      }, 300));
    }

    fetchCartContents() {
      fetch(`${theme.routes.cart}.js`)
        .then((response) => response.json())
        .then((data) => {
          this.addPersonalisationInfoToNotes(data);
        })
        .catch((error) => {
          console.error('Error fetching cart contents:', error);
        });
    }

    addPersonalisationInfoToNotes(cartData) {
      const textarea = this.querySelector('textarea');
      if (!textarea || !cartData.items) return;

      const personalizedProducts = cartData.items.filter(item => 
        item.properties && item.properties.hasOwnProperty('Personalised')
      );

      if (personalizedProducts.length > 0) {
        const formattedText = personalizedProducts.map(item => {
          const productName = item.product_title || item.title;
          const personalised = item.properties.Personalised || 'YES';
          const name = item.properties.Name || '';
          const number = item.properties.Number || '';

          let formattedText = `${productName}:
- Personalised: ${personalised}
- Name: ${name}
- Number: ${number}`;
          
          if (item.properties && item.properties._badge_id) {
            const badgeProduct = this.findBadgeProductInCart(cartData.items, item.properties._badge_id);
            if (badgeProduct) {
              formattedText += `\n- Badge: ${badgeProduct}`;
            }
          }
          
          return formattedText;
        }).join('\n\n');

        textarea.value = formattedText;

        // Update toggle label if it exists
        if (this.cartNoteToggle) {
          const label = textarea.value ? theme.strings.editCartNote : theme.strings.addCartNote;
          if (this.cartNoteToggle.textContent !== label) this.cartNoteToggle.textContent = label;
        }
      }
    }

    findBadgeProductInCart(cartItems, badgeVariantId) {
      const badgeItem = cartItems.find(item => item.variant_id == badgeVariantId);
      return badgeItem ? (badgeItem.product_title || badgeItem.title) : null;
    }
  }

  customElements.define('cart-note', CartNote);
}
